<template>
  <BasicModal
    :title="'トレロと連携する'"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="-container">
      <div class="input-box">
         <p style="text-align: left; padding: 15px;">
          Trelloのタスクを連携します。
        </p>
        <div v-if="!isBoard">
        <div style="text-align: left; padding: 15px;">
          APIキー：
          <input class="input" style="width: 358px; height: 24px; color: #222; font-size: 16px;" v-model="trelloInformation.APIkey"/>
        </div>
        <div style="text-align: left; padding: 15px;">
          トークン：
          <input class="input" style="width: 358px; height: 24px; color: #222; font-size: 16px;" v-model="trelloInformation.token"/>
        </div>
        </div>
        <div v-else>
          <div style="text-align: center;" v-if="trelloLoading">
            <p style="text-align: left; padding: 15px; padding-top: 0px;">
              ボードを探しています。
            </p>
            <span class="mdi mdi-loading mdi-spin mdi-48px"></span>
          </div>
          <div v-else-if="!trelloLoading&&!getTrelloTask">
            <p style="text-align: left; padding: 15px; padding-top: 0px;">
              連携するボードを選択してください。
            </p>
            <div class="board-list">
              <div v-for="(p, i) in trelloBoard" :key="i" style="margin-bottom: 8px;">
                <b-checkbox v-model="selectTrelloBoard" :native-value="p.id">{{p.name}}</b-checkbox>
              </div>
            </div>
          </div>
          <div style="text-align: center;" v-else-if="getTrelloTask">
            <p style="text-align: left; padding: 15px; padding-top: 0px;">
              連携しています。
            </p>
            <span class="mdi mdi-loading mdi-spin mdi-48px"></span>
          </div>
        </div>
      </div>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">閉じる</button>
      <button v-if="!isBoard" class="button is-primary" @click="createLinkTrelloAPI(trelloInformation)">連携する</button>
      <button v-else class="button is-primary" :disabled="getTrelloTask" @click="createLinkTrelloBoard(trelloInformation, selectTrelloBoard)">選択したボードを連携する</button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import displayDate from '@/functions/displayDate'
import { mapState } from 'vuex'

export default {
  components: {
    BasicModal
  },
  computed: {
    ...mapState('task', ['trelloBoard', 'trelloLoading', 'isBoard', 'getTrelloTask']),
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    taskList: {
      type: Array,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      trelloInformation: {
        APIkey: null,
        token: null
      },
      selectTrelloBoard:[],
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    createLinkTrelloAPI (data) {
      data.user = this.user.userHash
      this.$emit('createLinkTrelloAPI', data)
    },
    createLinkTrelloBoard (data, data2) {
      data.user = this.user.userHash
      this.$emit('createLinkTrelloBoard', {data, data2})
    },
    getUserName (hash) {
      let name = '-'
      for (const user of this.users) {
        if (user.user_hash === hash) {
          name = user.username
        }
      }
      return name
    },
    getExistData (taskList) {
      let cnt = 0
      for (const t of taskList) {
        cnt += t.user_task_log.length
      }
      return cnt > 0 ? true : false
    },
    displayDateStr (time) {
      if (!time) return '-'
      return displayDate(time)
    },
  }
}
</script>

<style lang="scss" scoped>
.-container {
  padding: 24px;
  overflow: auto;
}
.input-field {
  padding: 8px;
  text-align: left;
}
.table-box {
  display: table;
  max-height: calc(75vh - 180px);
  width: 100%;
  overflow: auto;
  border-bottom: solid thin #ccc;
}
.table-box::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.table-td {
  vertical-align: middle;
  border: solid thin #ccc;
  padding: 2px;
  p {
    text-align: center;
  }
}
.table-th {
  text-align: center;
  vertical-align: middle;
  border: solid thin #ccc;
  padding: 2px 8px;
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
.board-list {
  margin-top: 8px;
  overflow: auto;
  height: 300px;
}
.board-list::-webkit-scrollbar {
  width:  10px;
  height: 10px;
  visibility: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/Calendar/organisms/ModalLinkTrello.vue